(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tel-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('.tel-menu-btn');
    var nav = document.getElementById('tel-mobile-nav');
    if (!btn || !nav) return;

    var menuLinks = Array.prototype.slice.call(nav.querySelectorAll('a'));
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var scrollPosition = 0;
    var bodyLockStyles = {};

    function isMenuOpen() {
      return btn.getAttribute('aria-expanded') === 'true';
    }

    function openMenu() {
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
      bodyLockStyles = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width
      };

      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', 'Close navigation menu');
      nav.setAttribute('aria-hidden', 'false');
      nav.classList.add('tel-mobile-nav--open');
      document.documentElement.classList.add('tel-mobile-nav-open');
      document.body.classList.add('tel-mobile-nav-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollPosition + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      btn.textContent = 'CLOSE';

      if (menuLinks.length) {
        menuLinks[0].focus();
      }
    }

    function closeMenu(restoreFocus) {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Open navigation menu');
      nav.setAttribute('aria-hidden', 'true');
      nav.classList.remove('tel-mobile-nav--open');
      document.documentElement.classList.remove('tel-mobile-nav-open');
      document.body.classList.remove('tel-mobile-nav-open');
      document.body.style.position = bodyLockStyles.position || '';
      document.body.style.top = bodyLockStyles.top || '';
      document.body.style.left = bodyLockStyles.left || '';
      document.body.style.right = bodyLockStyles.right || '';
      document.body.style.width = bodyLockStyles.width || '';
      window.scrollTo(0, scrollPosition);
      btn.textContent = 'MENU';

      if (restoreFocus) {
        btn.focus();
      }
    }

    function handleMenuTrap(e) {
      if (!isMenuOpen() || e.key !== 'Tab') return;

      var focusableItems = [btn].concat(menuLinks);
      var firstItem = focusableItems[0];
      var lastItem = focusableItems[focusableItems.length - 1];
      var focusIndex = focusableItems.indexOf(document.activeElement);

      if (focusIndex === -1) {
        e.preventDefault();
        firstItem.focus();
      } else if (e.shiftKey && document.activeElement === firstItem) {
        e.preventDefault();
        lastItem.focus();
      } else if (!e.shiftKey && document.activeElement === lastItem) {
        e.preventDefault();
        firstItem.focus();
      }
    }

    btn.addEventListener('click', function () {
      if (isMenuOpen()) {
        closeMenu(false);
      } else {
        openMenu();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isMenuOpen()) {
        closeMenu(true);
      } else {
        handleMenuTrap(e);
      }
    });

    function handleDesktopQueryChange(e) {
      if (e.matches && isMenuOpen()) {
        closeMenu(false);
      }
    }

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', handleDesktopQueryChange);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(handleDesktopQueryChange);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
